import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";

import {
  handleCategory,
  handleHeader,
  handlePopup,
  handleStage,
  handleSubmit,
  setSelectedChapter,
} from "../redux/slice";
import DisplayQuestions from "./displayQuestions";
import {
  clearQuestions,
  handleCategories,
  showLoginPopup,
  updateCategories,
} from "../redux/editorSlice";
import ArrowPanel from "./arrowPanel";
import { getValidationMessages } from "../redux/selectors";
import { GetQuestionsByCategoryThunk } from "../redux/thunk";
import ValidationAlert from "./validationAlert";
import SkeletonLoader from "./loader/skeletonLoader";
import { useEffect, useState } from "react";
import { GetUserAccessThunk } from "../../../../pages/user/redux/userThunk";
import ToastComponent from "../../../../components/Other/Toast";
import toast from "react-hot-toast";
import AddQuestion from "./AddQuestion";
import GeneralRegister from "./registration/GeneralRegister";
import Popup from "../../../EventOrganiser/Popup";
import { commonLabels } from "../util/commonLabelAndFontSize";

function LeftPanel({ handleOnChange, onStepChange, goToStepByTarget }) {
  const dispatch = useDispatch();
  const [activeJoyrideCategory, setActiveJoyrideCategory] = useState(null);

  // Guard to prevent automatic tour step changes while Joyride is showing step 9.
  // Only blocks backward movement to steps 0-8. Allows onward movement to step 10+.
  const safeOnStepChange = (step) => {
    try {
      if (typeof window !== "undefined" && window.__JOY_STEP__ === 9) {
        // Block any backward movement (step < 9) while on step 9
        if (step < 9) return;
      }
    } catch (e) {}
    onStepChange(step);
  };

  const { isRegistered } = useSelector((state) => state.register);

  const {
    categories: selectedCategories,
    loader,
    questions,
    showPopup,
  } = useSelector((store) => store.createPaperEditor);
  const { user } = useSelector((store) => store.authSlice);

  useEffect(() => {
    // 🚫 Never auto-move steps for NORMAL users
    if (user.admin_id !== 104) return;

    const Tpe3len = questions.filter((q) => q.question_typeid === 3).length;
    const Tpe15len = questions.filter((q) => q.question_typeid === 15).length;

    // Demo flow ONLY
    if (Tpe3len === 5) {
      goToStepByTarget(".fill-blanks-step-15");
    }

    if (Tpe15len >= 5) {
      goToStepByTarget(".header-form-step");
    }
  }, [questions, user.admin_id]);
  const {
    formData,
    categories,
    chapters,
    isOpen,
    selectedChapter,
    mediumList,
  } = useSelector((store) => store.createQstnPaper);
  const medium_name =
    mediumList
      .find((m) => Number(m.id) === Number(formData.medium_id))
      ?.name?.toLowerCase() || "";
  const labels = commonLabels[medium_name === "hindi" ? "hi" : "en"];

  // useEffect(
  //   function () {
  //     const Tpe3len = questions.filter((q) => q.question_typeid === 3).length;

  //     // Only show registration popup if not in demo/tour mode (admin_id 104)
  //     if (!isRegistered && user.admin_id === 104 && Tpe3len > 0) {
  //       dispatch(showLoginPopup(true));
  //       dispatch(clearQuestions());
  //       safeOnStepChange(0);
  //     }
  //     const Tpe15len = questions.filter((q) => q.question_typeid === 15).length;
  //     const filterdCatData = selectedCategories.filter(
  //       (c) => c.type_id !== 3 && c.type_id !== "header"
  //     );

  //     if (Tpe3len === 5 && filterdCatData.length === 0) {
  //       // ToastComponent(
  //       //   user,
  //       //   "Please select a different category (e.g., Fill in the blanks).",
  //       //   1
  //       // );
  //       safeOnStepChange(6);
  //     }

  //     if (
  //       filterdCatData?.length === 1 &&
  //       !filterdCatData?.at(0)?.catQstns?.length
  //     ) {
  //       // ToastComponent(
  //       //   user,
  //       //   `Please select Any Chapter for ${filterdCatData.at(0).type_name}`,
  //       //   1
  //       // );
  //       safeOnStepChange(7);
  //     }

  //     if (
  //       Tpe15len >= 5 &&
  //       filterdCatData?.length === 1 &&
  //       filterdCatData?.at(0)?.catQstns?.length > 1
  //     ) {
  //       safeOnStepChange(9);
  //     }
  //   },
  //   [questions, user, selectedCategories, onStepChange]
  // );

  const handleCategoryChange = (e, category) => {
    const value = e.target.checked;

    const data = {
      id: category.value,
      name: category.label,
      title: category.title,
    };

    dispatch(handleCategories({ data, value }));
    dispatch(handleSubmit(false));

    // Move Joyride only when category is selected
    if (!value) return;

    // True / False (demo flow already handled by parent)
    // ✅ mark this category as active
    setActiveJoyrideCategory(category.value);

    // Demo case
    if (category.value === 3 && user.admin_id === 104) {
      ToastComponent(user, "Please select Any Chapter.", 1);
      setTimeout(() => {
        goToStepByTarget(".true-false-chapter-step-3");
      }, 300);
      return;
    }

    setTimeout(() => {
      goToStepByTarget(".no-of-questions-step");
    }, 300);
  };

  const handleAddNew = (category) => {
    console.log("Add new question for category:", category);
    dispatch(handlePopup(true));
    dispatch(handleCategory(category));
  };

  const handleCategoryDetailsChange = async (e, category) => {
    const value = e.target.value;
    const name = e.target.name;

    dispatch(updateCategories({ ...category, [name]: value }));
    dispatch(handleSubmit(false));

    // 🚫 DO NOTHING for typing
    if (name !== "chapter") return;

    await dispatch(
      GetQuestionsByCategoryThunk({
        subjectId: formData.subject,
        classId: formData.class,
        chapterId: value,
        categoryId: category.type_id,
        board_id: formData.board_id,
        medium_id: formData.medium_id,
      }),
    );

    // ✅ Move Joyride ONLY on chapter select
    if (category.type_id === 3 && user.admin_id === 104) {
      goToStepByTarget(".step-questions-3");
    } else if (category.type_id === 15 && user.admin_id === 104) {
      goToStepByTarget(".step-questions-15");
    } else {
      goToStepByTarget(".questions-select-step");
    }
  };

  const handlePanel = (category, value) => {
    const updatedCategory = { ...category, questionsPanel: value };
    dispatch(updateCategories(updatedCategory));
  };

  // if (loader) return <SkeletonLoader type={2} />;

  return (
    <>
      <div className="header-form-step">
        <div className="mt-2">
          <HeaderForm
            handleOnChange={handleOnChange}
            onGoBack={() => dispatch(handleStage(1))}
          />
        </div>

        <div className="mt-2 custom-height-box  category-select-step">
          {categories.map((category, i) => {
            const selected =
              selectedCategories.find((c) => c.type_id === category.value) ||
              null;

            const handleQstnPanel = (value) => {
              handlePanel(selected, value);
            };

            return (
              <div
                className={`${
                  category.value === 3
                    ? `true-false-step-${category.value}`
                    : category.value === 15
                      ? `fill-blanks-step-${category.value}`
                      : ""
                }`}
                key={i + 1}
              >
                {/* 🔹 ROW 1: Category + Custom Question */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "6px",
                    marginBottom: "3px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <input
                      type="checkbox"
                      id={`category-${i}`}
                      checked={!!selected}
                      onChange={(e) => handleCategoryChange(e, category)}
                    />
                    <label htmlFor={`category-${i}`}>{category.label}</label>
                  </div>

                  {selected && (
                    <button
                      className="add-own-question-btn"
                      style={{
                        background:
                          "linear-gradient(135deg, #1a4cca 0%, #0024c2 100%)",
                        color: "white",
                        borderRadius: "5px",
                        border: "none",
                        fontSize: "13px",
                        padding: "2px 6px",
                        cursor: "pointer",
                      }}
                      onClick={() => handleAddNew(category)}
                    >
                      + {labels.addYourOwnQuestion}
                    </button>
                  )}
                </div>

                {/* 🔹 ROW 2: Inputs */}
                {selected &&
                  (loader ? (
                    <SkeletonLoader type={3} />
                  ) : (
                    <div>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          marginBottom: "4px",
                          marginLeft: "15px",
                        }}
                      >
                        <div
                          className={`
    ${activeJoyrideCategory === category.value ? "no-of-questions-step" : ""}
    no-of-questions-step-${category.value}
  `}
                        >
                          <small>{labels.enterNoOfQuestions}</small>
                          <br />
                          <input
                            className="custom-cat-input"
                            name="questions"
                            type="number"
                            value={selected.questions ?? ""}
                            onChange={(e) =>
                              handleCategoryDetailsChange(e, selected)
                            }
                          />
                        </div>

                        <div
                          className={`
    ${activeJoyrideCategory === category.value ? "marks-per-question-step" : ""}
    marks-per-question-step-${category.value}
  `}
                        >
                          <small>{labels.marksPerQuestion}</small>
                          <br />
                          <input
                            className="custom-cat-input"
                            name="marks"
                            type="number"
                            value={selected.marks ?? ""}
                            onChange={(e) =>
                              handleCategoryDetailsChange(e, selected)
                            }
                          />
                        </div>
                      </div>

                      {/* 🔹 Chapter */}
                      <div
                        className={`
  ${activeJoyrideCategory === category.value ? "chapter-select-step" : ""}
  ${
    user.admin_id === 104
      ? category.value === 3
        ? `true-false-chapter-step-${category.value}`
        : category.value === 15
          ? `fill-blanks-chapter-step-${category.value}`
          : ""
      : ""
  }
`}
                      >
                        <Select
                          options={chapters}
                          value={
                            chapters.find(
                              (opt) => opt.value === selected.chapter,
                            ) || null
                          }
                          onChange={(e) => {
                            handleCategoryDetailsChange(
                              { target: { name: "chapter", value: e.value } },
                              selected,
                            );
                            dispatch(setSelectedChapter(e.value));
                          }}
                          isDisabled={loader}
                          placeholder={labels.selectChapter}
                          className="m-2"
                          classNamePrefix="custom-select"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 10001 }),
                          }}
                        />

                        <DisplayQuestions
                          questions={selected?.catQstns || []}
                          categoryName={selected.type_name}
                          categoryId={selected.type_id}
                          questionsPanel={selected?.questionsPanel}
                          handlePanel={handleQstnPanel}
                          isDisabled={loader}
                          activeJoyrideCategory={activeJoyrideCategory}
                          medium={medium_name}
                        />
                      </div>
                    </div>
                  ))}

                <hr />
              </div>
            );
          })}
        </div>
      </div>
      {isOpen && <AddQuestion />}
      {showPopup && <GeneralRegister onStepChange={onStepChange} />}
      <SubmitComponent
        onStepChange={onStepChange}
        goToStepByTarget={goToStepByTarget}
      />
    </>
  );
}

function HeaderForm({ handleOnChange, onGoBack }) {
  const dispatch = useDispatch();

  const { headerPanel, formData, mediumList } = useSelector(
    (store) => store.createQstnPaper,
  );
  const { headers } = useSelector((store) => store.masterData);
  const { logo: Logo } = useSelector((store) => store.masterData);

  const medium_name =
    mediumList
      .find((m) => Number(m.id) === Number(formData.medium_id))
      ?.name?.toLowerCase() || "";
  const labels = commonLabels[medium_name === "hindi" ? "hi" : "en"];
  const headerTypes = formData.headerTypes || [];
  const hasType2 = headerTypes.includes("2");
  const hasType3 = headerTypes.includes("3");

  useEffect(() => {
    if (hasType3 && Logo && !formData.schoolLogoUrl) {
      handleOnChange({
        target: { name: "schoolLogoUrl", value: Logo },
      });
    }
  }, [hasType3, Logo]);

  useEffect(() => {
    if (hasType2 && headers?.length > 0 && !formData.headerImageUrl) {
      handleOnChange({
        target: {
          name: "headerImageUrl",
          value: headers[0],
        },
      });
    }
  }, [hasType2, headers]);

  const isSelected = (value) => headerTypes.includes(value);

  const toggleHeaderType = (value) => {
    let updated = [...headerTypes];

    if (updated.includes(value)) {
      updated = updated.filter((v) => v !== value);
    } else {
      // If selecting Letter Head → clear others
      if (value === "2") {
        updated = ["2"];
      } else {
        // If selecting 1 or 3 → remove Letter Head
        updated = updated.filter((v) => v !== "2");
        updated.push(value);
      }
    }

    handleOnChange({
      target: {
        name: "headerTypes",
        value: updated,
      },
    });
  };

  // const { questions } = useSelector((store) => store.createPaperEditor);
  // const { subjectName, className } = useSelector(getNameById);

  // const updatedFormData = { ...formData, subjectName, className };
  // const data = getHeaderData(updatedFormData).qstnData;

  // const handleOnChange2 = (e) => {
  //   const value = e.target.checked;
  //   dispatch(handleCheckBox({ type: value, data }));
  // };

  const handleHeader1 = (value) => {
    dispatch(handleHeader(value));
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <ArrowPanel
            panel={headerPanel}
            event={handleHeader1}
            // label="Header"
            label={labels.header}
          />
        </div>
        <button
          className="go-back-btn"
          onClick={(e) => {
            e.preventDefault();
            onGoBack();
          }}
          style={{
            background: "linear-gradient(135deg, #6c4cff 0%, #a855f7 100%)",
            color: "#fff",
            border: "none",
            borderRadius: "10px",
            padding: "6px 14px",
            fontSize: "11px",
            fontWeight: 500,
            cursor: "pointer",
            whiteSpace: "nowrap",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            lineHeight: "1",
          }}
        >
          <span style={{ fontSize: "14px", lineHeight: "1" }}></span>
          {/* Go Back */}
          {labels.goBack}
        </button>
      </div>

      {headerPanel && (
        <form className="mx-3">
          {false && (
            <div className="mt-2">
              <label>School Name</label>
              <br />
              <input
                type="text"
                className="custom-input m-2"
                placeholder="Enter School Name"
                style={{ maxWidth: "300px" }}
                name="schoolName"
                onChange={handleOnChange}
                value={formData.schoolName}
                required
              />
            </div>
          )}
          {false && (
            <div className="mt-2">
              <label>Examination Name</label>
              <br />
              <input
                type="text"
                className="custom-input m-2"
                placeholder="Enter Examination Name"
                style={{ maxWidth: "300px" }}
                name="examName"
                onChange={handleOnChange}
                value={formData.examName}
                required
              />
            </div>
          )}
          {/* Display Header */}
          <div className="mt-2 d-flex align-items-center">
            <input
              type="checkbox"
              id="displayHeader"
              className="me-2"
              checked={formData.displayHeader === "true"}
              onChange={(e) => {
                const name = "displayHeader";
                const value = e.target.checked ? "true" : "false";
                handleOnChange({ target: { name, value } });
              }}
            />
            <label htmlFor="displayHeader" className="custom-label-qstn mb-0">
              {/* Display Header */}
              {labels.displayHeader}
            </label>
          </div>

          {/* Header Type Radios */}
          {formData.displayHeader === "true" && (
            <>
              <div className="mt-1 ms-4 d-flex align-items-center gap-4">
                {/* Normal Header */}
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={isSelected("1")}
                    disabled={isSelected("2")}
                    onChange={() => toggleHeaderType("1")}
                  />
                  &nbsp;
                  <label className="mb-0">
                    {/* Normal Header */}
                    {labels.normalHeader}
                  </label>
                </div>

                {/* Letter Head */}
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={isSelected("2")}
                    disabled={isSelected("1") || isSelected("3")}
                    onChange={() => toggleHeaderType("2")}
                  />
                  &nbsp;
                  {/* <label className="mb-0">Letter Head</label> */}
                  <label className="mb-0">{labels.letterHead}</label>
                </div>

                {/* Logo Only */}
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={isSelected("3")}
                    disabled={isSelected("2")}
                    onChange={() => toggleHeaderType("3")}
                  />
                  &nbsp;
                  <label className="mb-0">{labels.onlyLogo}</label>
                </div>
              </div>

              {/* Letter Head Extra Fields */}
              {hasType2 && (
                <div className="ms-4 mt-2">
                  {/* Height & Width */}
                  <div className="d-flex align-items-center gap-3 mb-2">
                    <div>
                      <label>
                        {labels.height}
                        {/* Height */}
                      </label>
                      <input
                        type="number"
                        className="custom-cat-input ms-2"
                        name="headerImgHeight"
                        value={formData.headerImgHeight}
                        onChange={handleOnChange}
                      />
                    </div>

                    <div>
                      <label>
                        {labels.width}
                        {/* Width */}
                      </label>
                      <input
                        type="number"
                        className="custom-cat-input ms-2"
                        name="headerImgWidth"
                        value={formData.headerImgWidth}
                        onChange={handleOnChange}
                      />
                    </div>
                  </div>

                  {/* Header Images */}
                  <div className="d-flex gap-2">
                    {headers?.length === 0 ? (
                      <p className="text-danger m-0">
                        Please upload header images in master data
                      </p>
                    ) : (
                      headers.map((header, i) => (
                        <img
                          key={i}
                          src={header}
                          alt="header"
                          style={{
                            width: "40px",
                            height: "30px",
                            cursor: "pointer",
                            border:
                              formData.headerImageUrl === header
                                ? "2px solid #1976d2"
                                : "1px solid #ccc",
                          }}
                          onClick={() =>
                            handleOnChange({
                              target: {
                                name: "headerImageUrl",
                                value: header,
                              },
                            })
                          }
                        />
                      ))
                    )}
                  </div>
                </div>
              )}
              {hasType3 && (
                <div className="ms-4 mt-2">
                  {/* Width & Height Controls */}
                  {/* {formData.schoolLogoUrl && ( */}
                  <>
                    <div className="d-flex align-items-center gap-3 mb-2">
                      <div>
                        <label>{labels.width}</label>
                        <input
                          type="number"
                          className="custom-cat-input ms-2"
                          name="logoWidth"
                          value={formData.logoWidth}
                          onChange={handleOnChange}
                        />
                      </div>

                      <div>
                        <label>{labels.height}</label>
                        <input
                          type="number"
                          className="custom-cat-input ms-2"
                          name="logoHeight"
                          value={formData.logoHeight}
                          onChange={handleOnChange}
                        />
                      </div>
                    </div>
                  </>
                  {/* )} */}
                  {!Logo ? (
                    <p className="text-danger">
                      Please upload logo in master data
                    </p>
                  ) : (
                    <div className="d-flex align-items-center gap-3">
                      <img
                        src={Logo}
                        alt="school-logo"
                        style={{
                          width: "40px",
                          height: "30px",
                          objectFit: "contain",
                          cursor: "pointer",
                          border:
                            formData.schoolLogoUrl === Logo
                              ? "2px solid #1976d2"
                              : "1px solid #ccc",
                        }}
                        onClick={() =>
                          handleOnChange({
                            target: {
                              name: "schoolLogoUrl",
                              value: Logo,
                            },
                          })
                        }
                      />
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          <br />
          <input
            type="checkbox"
            id="terms"
            checked={formData.displayTerms === "true"}
            onChange={(e) => {
              const name = "displayTerms";
              const value = e.target.checked ? String(true) : String(false);
              handleOnChange({ target: { name, value } });
            }}
          />
          <label className="mx-2 custom-label-qstn" htmlFor="terms">
            {/* Terms & Conditions */}
            {labels.termsAndConditions}
          </label>
        </form>
      )}
      <hr />
    </>
  );
}

function SubmitComponent({ onStepChange, goToStepByTarget }) {
  const dispatch = useDispatch();

  const { isSubmitted } = useSelector((store) => store.createQstnPaper);
  const { user: userData } = useSelector((store) => store.authSlice);
  const { isRegistered } = useSelector((state) => state.register);
  const [isOpen, setIsOpen] = useState(false);

  const { displayMessage, message: validationMessage } = useSelector(
    getValidationMessages,
  );
  const { userAccessData, userCountRestrictions } = useSelector(
    (state) => state.user,
  );

  // const planType = userData.payments?.at(0).plan_type || "";
  const planType = userData?.payments?.[0]?.plan_type || "";

  useEffect(() => {
    dispatch(GetUserAccessThunk());
  }, [dispatch]);

  useEffect(() => {
    if (isSubmitted) {
      if (!displayMessage) {
        // alert("Submit now");
        toast.dismiss();
        dispatch(handleStage(3));
      }
      setTimeout(() => {
        goToStepByTarget(".print-button-step");
      }, 300);
    }
  }, [isSubmitted, displayMessage, dispatch]);

  const handleSubmitbtn = async (e) => {
    e.preventDefault();

    // if (isRegistered) {
    //   onStepChange(0);
    //   const msg =
    //     "Registration Required\n\n" +
    //     "To explore more features and create unlimited papers, you must login or register.\n\n" +
    //     "Click OK to continue.";

    //   window.confirm(msg);
    //   window.location.href = "https://mydocmaster.com/login";
    //   return;
    // }
    // if (isRegistered) {
    //   onStepChange(0);
    //   setShowPopup(true);

    //   return;
    // }
    onStepChange(0);

    if (
      userData.roles === "trial" &&
      userAccessData?.total_papers >= userCountRestrictions?.demo?.qstnPapers
    ) {
      return alert(
        `You are in a trial period and can create only ${userCountRestrictions?.demo?.qstnPapers} Papers.`,
      );
    }

    if (
      planType === "customized" &&
      userAccessData?.total_papers >=
        userCountRestrictions?.individual?.qstnPapers
    ) {
      return alert(
        `You are in Inidividual Plan and can create only ${userCountRestrictions.individual.qstnPapers} events.`,
      );
    }

    dispatch(handleSubmit(true));

    // if (!displayMessage) {
    //   dispatch(handleStage(3));
    // }
  };

  return (
    <>
      {displayMessage && <ValidationAlert message={validationMessage} />}
      {/* {displayMessage && isSubmitted && (
        <ValidationAlert message={validationMessage} />
      )} */}
      {/* {showPopup && (
        <Popup
          title="Complete Your Details"
          minHeight="400px"
          maxWidth="500px"
          onClose={() => {
            setShowPopup(false);
            window.location.href = "https://mydocmaster.com/login";
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div style={{ marginBottom: "24px" }}>
              <p>To get the final output of your work or to Print / Download</p>
              <br />
              <p>Complete the registration process with your Name Details.</p>
            </div>

            <button
              onClick={() =>
                (window.location.href = "https://mydocmaster.com/login")
              }
              style={{
                padding: "12px 24px",
                borderRadius: "8px",
                color: "white",
                fontWeight: "600",
                backgroundImage:
                  "linear-gradient(to right, #3b82f6, #a855f7, #ec4899)",
                boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                border: "none",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.filter = "brightness(1.15)";
              }}
              onMouseLeave={(e) => {
                e.target.style.filter = "brightness(1)";
              }}
              onMouseDown={(e) => {
                e.target.style.transform = "scale(0.95)";
              }}
              onMouseUp={(e) => {
                e.target.style.transform = "scale(1)";
              }}
            >
              Proceed
            </button>
          </motion.div>
        </Popup>
      )} */}

      <div className="d-flex gap-2">
        <button
          className="btn btn-primary submit-btn-final"
          onClick={handleSubmitbtn}
          // disabled={displayMessage && isSubmitted}
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default LeftPanel;
